<template>
  <div class="ma-4">
    <v-snackbar v-model="messageIsShown" top>
      {{ message }}
      <v-btn color="pink" text @click="messageIsShown = false"> Close </v-btn>
    </v-snackbar>
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-row>
            <v-col cols="12" md="12">
              <v-card class="mx-auto">
                <v-data-table :headers="headers" :items="roles">
                  <template v-slot:top>
                    <v-container class="d-flex justify-end">
                      <v-btn
                        color="#2b3990"
                        class="mb-2 white--text"
                        @click="showAddRole()"
                      >
                        <v-icon left>add</v-icon>
                        Add Role</v-btn
                      >
                    </v-container>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="viewRole(item)">
                      mdi-eye
                    </v-icon>
                  </template>
                </v-data-table>
              </v-card>

              <v-dialog
                v-model="showRoleDialog"
                max-width="80%"
                :retain-focus="false"
              >
                <v-card>
                  <v-card-title style="background-color: #2b3990; color: #fff">
                    <span v-if="roleId == ''"> Add User Role </span>
                    <span v-else> Update User Role </span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <validation-observer ref="roleObserver">
                        <v-row>
                          <v-col cols="12" sm="12" md="6">
                            <validation-provider
                              rules="required:uniqueRoleName"
                              v-slot="{ errors }"
                              name="Role name"
                            >
                              <v-text-field
                                v-model="roleName"
                                label="Role name"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                        </v-row>

                        <v-row
                          v-for="(permission, index) in permissions"
                          :key="index"
                        >
                          <v-col cols="12" sm="12" md="4">
                            <validation-provider
                              :rules="`${
                                permissionIsRequired(permission)
                                  ? 'required|resourceValidation'
                                  : ''
                              }`"
                              v-slot="{ validate, errors }"
                              name="Resource"
                            >
                              <v-text-field
                                v-model="permission.resource"
                                label="Resource/Model"
                                class="resource"
                                :error-messages="errors"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" sm="10" md="6">
                            <validation-provider
                              :rules="`${
                                permissionIsRequired(permission)
                                  ? 'required|actionValidation'
                                  : ''
                              }`"
                              v-slot="{ validate, errors }"
                              name="Actions"
                            >
                              <v-select
                                :items="[...actions, ...permission.actions]"
                                v-model="permission.actions"
                                label="Actions"
                                multiple
                                chips
                                :error-messages="errors"
                              >
                                <template v-slot:append-item>
                                  <v-divider class="mb-2"></v-divider>
                                  <v-list-item>
                                    <v-list-item-content>
                                      <v-text-field
                                        v-model="customAction"
                                        label="Custom action"
                                        :error-messages="errors"
                                        @keyup.enter="addToActions(index)"
                                      />
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                              </v-select>
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" sm="2" md="2">
                            <v-btn
                              class="mx-2"
                              fab
                              dark
                              x-small
                              color="red"
                              @click="removeResource(permission, index)"
                              v-if="permissions.length > 1"
                            >
                              <v-icon dark> mdi-minus </v-icon>
                            </v-btn>
                            <v-btn
                              class="mx-2"
                              fab
                              dark
                              x-small
                              color="indigo"
                              @click="addResource()"
                              v-if="
                                index === permissions.length - 1 &&
                                showAddPermissionButton
                              "
                            >
                              <v-icon dark> mdi-plus </v-icon>
                            </v-btn>
                          </v-col>
                          <v-spacer />
                        </v-row>
                        <v-row>
                          <v-btn
                            v-if="roleId == ''"
                            color="#2b3990"
                            class="mb-2 white--text"
                            @click="saveRole()"
                          >
                            Save Role
                          </v-btn>

                          <v-btn
                            v-else
                            color="#2b3990"
                            class="mb-2 white--text"
                            @click="updateRole(roleId)"
                          >
                            Update Role
                          </v-btn>
                        </v-row>
                      </validation-observer>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
const RolesService = require("../service/roles.service.js");

import { extend, ValidationObserver, ValidationProvider } from "vee-validate";

extend("resourceValidation", {
  validate: (value) => {
    return ["", null, undefined].indexOf(value) === -1;
  },
  message: "Resource is required for each permission.",
});

extend("roleNameExists", {
  validate(value, args) {
    console.log(args);
    const index = args.roleNames.findIndex((role) => role.Name === value);
    return index === -1;
  },
  params: ["roleNames"],
  message: "Role name must be unique.",
});

extend("actionValidation", {
  validate: (value) => {
    return Array.isArray(value) && value.length > 0;
  },
  message: "Permission must have an action.",
});

extend('uniqueRoleName', {
  async validate(value) {
    
  console.log('unique role check.');  
    // Make an API call to check if the email is unique
    RolesService.getByName(value).then(() => {
      return false;
    }).catch((error) => {
      console.log(error);
      return true;
    });
  },
  message: '{_field_} must be unique.'
});

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data: () => ({
    headers: [
      {
        text: "Role",
        value: "Name",
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
      },
    ],
    roles: [],
    actions: ["List", "Show", "Add", "Edit", "Delete", "Sign"],
    resource: "",
    resourceActions: [],
    roleName: "",
    message: "",
    messageIsShown: false,
    showRoleDialog: false,
    showEditDialog: false,
    permissions: [
      {
        resource: "",
        actions: [],
      },
    ],
    deletedPermission: [],
    roleId: "",
    customAction: "",
  }),

  created() {
    this.getRoles();
  },

  methods: {
    getRoles: function () {
      this.isLoading = true;
      RolesService.get({})
        .then((res) => {
          this.roles = res.data.roles;
        })
        .finally(() => (this.isLoading = false));
    },

    saveRole() {
      const roleData = {
        Name: this.roleName,
        Permissions: this.permissions,
      };

      RolesService.create(roleData)
        .then((response) => {
          this.roles.push(response.data.role);

          this.showMessage(response.data.message);
        })
        .catch((error) => {
          this.message = error.message;
          console.dir(error, {depth: null});
          this.showMessage(this.message);
        })
        .finally(() => {
          this.showRoleDialog = false;
          this.clearData();
        });
    },

    updateRole(roleId) {
      const roleData = {
        Name: this.roleName,
        Permissions: this.permissions,
      };

      const roleIndex = this.roles.findIndex((role) => role._id === roleId);
      let role = this.roles[roleIndex];

      RolesService.update(roleId, roleData)
        .then((response) => {
          (role.Name = this.roleName), (role.Permissions = this.permissions);
          this.roles[roleIndex] = role;

          this.showMessage(response.data.message);
        })
        .catch((error) => {
          this.message = error.message;
        })
        .finally(() => {
          this.showRoleDialog = false;
          this.clearData();
        });
    },

    showAddRole() {
      this.clearData();
      this.showRoleDialog = true;
      this.addResource();
    },

    viewRole(role) {
      this.showAddRole();
      this.roleId = role._id;
      this.roleName = role.Name;
      this.permissions = role.Permissions;

      if (this.permissions.length === 0) this.addResource();
    },

    addResource() {
      this.permissions.push({
        resource: "",
        actions: [],
      });
    },

    removeResource(permission, index) {
      if (permission._id != "") {
        this.deletedPermission.push(permission._id);
      }

      this.permissions.splice(index, 1);
    },

    permissionIsRequired(permission) {
      if (permission.resource == "" || permission.actions.length == 0) {
        return true;
      }

      return false;
    },

    clearData() {
      this.roleId = "";
      this.roleName = "";
      this.permissions = [];
    },
    showMessage(message) {
      this.message = message;
      this.messageIsShown = true;
    },
    addToActions(index) {
      this.permissions[index].actions.push(this.customAction);
      this.customAction = "";
    },

    roleExists(roleName) {
      const roleIndex = this.roles.findIndex((role) => role.Name === roleName);
      if (roleIndex > -1) {
        return true;
      }
      return false;
    },
  },
  validations: {
    permissions: {
      resourceValidation: (value) => value.resource,
      actionValidation: (value) => value.actions,
    }
  },
  computed: {
    showAddPermissionButton() {
      const lastPermission = this.permissions[this.permissions.length - 1] ?? {
        resource: "",
        actions: [],
      };

      if (lastPermission.resource == "" || lastPermission.actions.length == 0) {
        return false;
      }

      return true;
    },
  },
};
</script>
<style>
.resource .v-text-field__slot {
  min-height: 42px;
}
</style>